<template>
  <section>
    <div class="loader-container">
      <div class="animated-redirect">
        <div class="animated-loader">
          <div class="curve" />
          <div class="ball-container">
            <div class="ball" />
          </div>
        </div>
        <div class="product-logos">
          <div class="logo-from">
            <img
              :src="keuzeLogo"
              alt="Keuze logo"
            >
          </div>
          <div class="logo-to">
            <img
              v-if="product"
              :src="product.provider_logo"
              :alt="product.provider_name"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="subtext">
      <span> We sturen je naar de juiste bestelpagina </span>
      <span v-if="product">
        van <strong>{{ product.provider_name }}</strong>
      </span>
      <div class="outlink-container">
        <a
          :href="signupURL"
          class="outlink"
          rel="nofollow"
        >Klik hier als je niet doorgestuurd wordt</a>
        <span
          class="loader-line"
          :style="'width: ' + timeLeftPercentage + '%'"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
    props: {
        product: Object,
    },
    data() {
        return {
            loading: true,

            redirectTimeout: 3,
            redirectionTimer: null,
            timeLeft: 0,

            trackingParam: null,
        };
    },

    computed: {
        keuzeLogo() {
            return '/assets/keuze/keuze-logo.svg';
        },
        productId() {
            return new URLSearchParams(window.location.search).get('prodid');
        },
        timeLeftPercentage() {
            return 100 - Math.round((this.timeLeft / this.redirectTimeout) * 100);
        },
        conversionValue() {
            if (this.product) {
                return this.product.cval;
            }
            return 1;
        },
        signupURL() {
            let url;
            let tracking;

            if (this.trackingParam === null) {
                tracking = 'unknown';
            } else {
                tracking = this.trackingParam;
            }

            if (this.product) {
                url = this.product.signup_url;
            }

            url = `https://api-privatelease.keuze.nl/v2/click/vlg31G3x4ndQCXUl-3/${this.productId}/signup`;

            // Add tracking to URL:
            const urlObject = new URL(url);
            urlObject.searchParams.set('t', tracking);
            return urlObject;
        },
    },

    mounted() {
        this.timeLeft = this.redirectTimeout;

        this.loading = false;

        // Load tracking parameter. Keep trying until we have one (every 200ms).
        const intervalTimer = setInterval(() => {
            this.setTracking();

            if (this.trackingParam !== null) {
                clearInterval(intervalTimer);
            }
        }, 200);
        this.startRedirect();
    },
    methods: {
        startRedirect() {
            if (!this.loading) {
                this.trackClickOut();

                if (this.redirectionTimer !== null) {
                    window.clearTimeout(this.redirectionTimer);
                }
                window.setTimeout(() => {
                    window.location = this.signupURL;
                }, this.redirectTimeout * 1000 + 1000);

                this.startCountDown();
            }
        },
        startCountDown() {
            this.timeLeft = this.redirectTimeout;
            window.setInterval(() => {
                if (this.timeLeft > 0) {
                    this.timeLeft -= 1;
                }

                if (this.timeLeft < 0) {
                    this.timeLeft = 0;
                }
            }, 1000);
        },
        trackClickOut() {
            const clickOutEventData = { product_id: this.productID, conversion_value: this.conversionValue };

            if (this.hasRealData) {
                clickOutEventData.provider_name = this.product.provider_name;
            }

            this.logAnalyticsEvent('compare-privatelease.outclick', clickOutEventData);
        },
        setTracking() {
            if (typeof window.global_tracking !== 'undefined' && this.trackingParam === null) {
                this.trackingParam = window.global_tracking;
            }
        },
    },
};
</script>

<style lang="scss">
@use "assets/scss/_helpers/breakpoint" as breakpoint;
@use 'assets/scss/_variables/colors';
@import "variables";

.click-out-component {
  width: 100%;
}

.loader-container {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 140px;
}

.outlink-container {
  position: relative;
  display: inline-flex;
  flex-flow: column;

  .outlink {
    color: colors.$link-base-default;

    &:visited {
      color: colors.$link-base-default;
    }
  }

  .loader-line {
    display: inline-flex;
    width: 100%;
    height: 2px;
    background-color: colors.$link-base-default;
    transition: width 1s linear;
  }
}

.animated-redirect {
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;

  .animated-loader {
    position: relative;
    display: flex;

    .curve {
      position: absolute;
      left: 0;
      right: 0;
      bottom: -85px;
      margin: auto;
      border-radius: 100%;
      border-top: 1px solid #ccc;
      width: 200px;
      height: 200px;
      z-index: 0;
    }

    .ball-container {
      position: absolute;
      left: 0;
      right: 0;
      bottom: -70px;
      margin: auto;
      width: 160px;
      height: 160px;
      opacity: 0;
      animation: transfor 1.5s ease-in-out infinite;
    }

    .ball {
      width: 15px;
      height: 15px;
      background-color: colors.$all-orange-60;
      border-radius: 100%;
      border-top-right-radius: 0;
      z-index: 1000;
    }

    @keyframes transfor {
      0% {
        transform: rotate(-45deg);
        opacity: 0;
      }

      30% {
        opacity: 1;
      }

      70% {
        opacity: 1;
      }

      100% {
        transform: rotate(135deg);
        opacity: 0;
      }
    }
  }

  .product-logos {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;

    & > div {
      display: inline-flex;
      width: 40%;
      height: auto;
      align-items: center;

      img {
        width: 100%;
      }
    }
  }
}

.subtext {
  text-align: center;
  margin-top: 30px;
  line-height: 2em;
  font-size: 18px;
}

.subtitle-element.large:first-of-type {
  display: none;
}
</style>
